import { siteStats } from '@/mocks/categories';

const heroCards = [
  {
    id: 'hero-card-01',
    title: '雾港迷航',
    meta: '电影 · 今日上线',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20foggy%20harbor%20and%20lone%20cargo%20ship%2C%20warm%20sepia%20amber%20tones%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-hero-01&orientation=portrait',
  },
  {
    id: 'hero-card-02',
    title: '长风渡口',
    meta: '剧集 · 更新至 18 集',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20riverside%20ferry%20town%20at%20golden%20dusk%2C%20warm%20orange%20tones%2C%20minimal%20graphic%20design%2C%20no%20text&width=400&height=600&seq=blueberry-hero-02&orientation=portrait',
  },
  {
    id: 'hero-card-03',
    title: '星轨旅人',
    meta: '动漫 · 更新至 09 话',
    poster:
      'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20of%20a%20train%20traveling%20between%20warm%20golden%20planets%2C%20vivid%20illustration%2C%20no%20text&width=400&height=600&seq=blueberry-hero-03&orientation=portrait',
  },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cinematic%20backdrop%20with%20soft%20amber%20and%20terracotta%20light%20streaks%2C%20blurred%20film%20grain%20texture%2C%20dark%20atmosphere%20with%20glowing%20highlights%2C%20no%20text&width=1600&height=900&seq=blueberry-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-36 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-6 animate-fade-up">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-100 bg-foreground-950/50 border border-accent-500/40 px-3 py-1.5 rounded-full">
              <i className="ri-live-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              今日已整理 8 条新内容
            </span>

            <h1 className="font-heading mt-5 text-3xl md:text-5xl font-black leading-tight text-background-50">
              蓝莓视频资源
              <span className="block mt-2 text-accent-400">热门新片与全集内容，一页掌握更新动态</span>
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
              本站把每天新上线的电影、剧集、动漫、综艺与纪实内容集中整理在同一页：你可以先看今日更新速递确认有没有在追的条目，再按类型筛选热门新片，或直接进追更专区查看总集数与最新进度。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#updates"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line" aria-hidden="true"></i>
                查看今日更新
              </a>
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line" aria-hidden="true"></i>
                浏览热门新片
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 border-t border-background-50/15 pt-6">
              {siteStats.map((stat) => (
                <div key={stat.id}>
                  <dt className="text-[11px] md:text-xs text-background-300">{stat.label}</dt>
                  <dd className="font-heading mt-1 text-lg md:text-2xl font-bold text-accent-400">{stat.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-3 gap-3 md:gap-4 max-w-md lg:max-w-none mx-auto">
              {heroCards.map((card, index) => (
                <figure
                  key={card.id}
                  className={`animate-float-card ${index === 1 ? 'mt-0 lg:-mt-8' : index === 2 ? 'mt-0 lg:mt-6' : ''}`}
                  style={{ animationDelay: `${index * 0.6}s` }}
                >
                  <div className="w-full aspect-[2/3] rounded-lg overflow-hidden border border-background-50/20 bg-foreground-900">
                    <img src={card.poster} alt={`${card.title} 海报`} className="w-full h-full object-cover object-top" />
                  </div>
                  <figcaption className="mt-2">
                    <p className="text-sm font-medium text-background-50 truncate">{card.title}</p>
                    <p className="text-[11px] text-background-300 truncate">{card.meta}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}